import React, { useState, useEffect } from 'react';

const NAVY = '#1f4e79';
const ORANGE = '#f26522';
const GREY = '#6b7280';
const LIGHT = '#f8fafc';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=Inter:wght@300;400;500;600&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html { scroll-behavior: smooth; }
  body { font-family: 'Inter', sans-serif; color: #0f172a; background: #fff; overflow-x: hidden; -webkit-font-smoothing: antialiased; }
  .lp { width: 100%; }

  /* ══ EXIT INTENT POPUP ══ */
  .ei-overlay {
    position: fixed; inset: 0; z-index: 9999;
    background: rgba(15,23,42,0.65);
    backdrop-filter: blur(6px);
    display: flex; align-items: center; justify-content: center;
    padding: 20px;
    animation: fadeIn 0.3s ease forwards;
  }
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  .ei-card {
    background: #fff; border-radius: 24px;
    width: 100%; max-width: 480px;
    overflow: hidden;
    box-shadow: 0 32px 80px rgba(0,0,0,0.25);
    animation: slideUp 0.35s cubic-bezier(0.34,1.56,0.64,1) forwards;
  }
  @keyframes slideUp {
    from { opacity: 0; transform: translateY(40px) scale(0.95); }
    to { opacity: 1; transform: translateY(0) scale(1); }
  }
  .ei-top {
    background: linear-gradient(135deg, ${NAVY} 0%, #0d2d52 100%);
    padding: 32px 32px 28px;
    position: relative;
  }
  .ei-top::before {
    content: '';
    position: absolute; top: -60px; right: -60px;
    width: 200px; height: 200px; border-radius: 50%;
    background: radial-gradient(circle, rgba(242,101,34,0.20) 0%, transparent 65%);
    pointer-events: none;
  }
  .ei-close {
    position: absolute; top: 16px; right: 16px;
    width: 32px; height: 32px; border-radius: 50%;
    background: rgba(255,255,255,0.12); border: none; cursor: pointer;
    color: rgba(255,255,255,0.70); font-size: 16px;
    display: flex; align-items: center; justify-content: center;
    transition: all 0.2s;
  }
  .ei-close:hover { background: rgba(255,255,255,0.20); color: #fff; }
  .ei-wait-badge {
    display: inline-flex; align-items: center; gap: 6px;
    background: rgba(242,101,34,0.20); border: 1px solid rgba(242,101,34,0.30);
    padding: 4px 12px; border-radius: 20px; margin-bottom: 14px;
    font-size: 11px; font-weight: 700; color: ${ORANGE};
    letter-spacing: 0.5px; text-transform: uppercase;
  }
  .ei-emoji { font-size: 14px; }
  .ei-h2 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 26px; font-weight: 800; color: #fff;
    line-height: 1.2; letter-spacing: -0.5px; margin-bottom: 8px;
  }
  .ei-h2 span { color: ${ORANGE}; }
  .ei-sub { font-size: 14px; color: rgba(255,255,255,0.60); line-height: 1.6; }
  .ei-body { padding: 28px 32px 32px; }
  .ei-usp { display: flex; flex-direction: column; gap: 8px; margin-bottom: 22px; }
  .ei-usp-item {
    display: flex; align-items: center; gap: 10px;
    font-size: 13px; font-weight: 500; color: #374151;
  }
  .ei-usp-check {
    width: 20px; height: 20px; border-radius: 50%; flex-shrink: 0;
    background: rgba(34,197,94,0.12);
    display: flex; align-items: center; justify-content: center;
    color: #16a34a; font-size: 11px; font-weight: 700;
  }
  .ei-label {
    font-size: 13px; font-weight: 600; color: #374151;
    margin-bottom: 10px; display: block;
  }
  .ei-input-row { display: flex; gap: 8px; margin-bottom: 10px; }
  .ei-prefix {
    display: flex; align-items: center; gap: 5px;
    background: #f8fafc; border: 1.5px solid #e2e8f0;
    border-radius: 10px; padding: 0 12px;
    font-size: 13px; font-weight: 600; color: ${NAVY};
    white-space: nowrap; flex-shrink: 0;
  }
  .ei-input {
    flex: 1; border: 1.5px solid #e2e8f0; border-radius: 10px;
    padding: 12px 14px; font-family: 'Inter', sans-serif;
    font-size: 14px; color: #0f172a; background: #f8fafc; outline: none;
    transition: all 0.2s;
  }
  .ei-input:focus { border-color: ${ORANGE}; background: #fff; box-shadow: 0 0 0 3px rgba(242,101,34,0.10); }
  .ei-input::placeholder { color: #94a3b8; }
  .ei-btn {
    width: 100%; padding: 14px;
    background: linear-gradient(135deg, #25d366, #128c7e);
    color: #fff; border: none; cursor: pointer;
    border-radius: 10px; font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 14px; font-weight: 700;
    display: flex; align-items: center; justify-content: center; gap: 8px;
    transition: all 0.2s; box-shadow: 0 4px 14px rgba(37,211,102,0.30);
    margin-bottom: 10px;
  }
  .ei-btn:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 8px 20px rgba(37,211,102,0.40); }
  .ei-btn:disabled { background: #cbd5e1; box-shadow: none; cursor: not-allowed; }
  .ei-note { font-size: 11px; color: #94a3b8; text-align: center; line-height: 1.5; }
  .ei-skip {
    display: block; text-align: center; margin-top: 14px;
    font-size: 12px; color: #94a3b8; cursor: pointer;
    background: none; border: none; width: 100%;
    transition: color 0.2s;
  }
  .ei-skip:hover { color: #64748b; }
  .ei-success { text-align: center; padding: 12px 0; }
  .ei-success-icon { font-size: 48px; margin-bottom: 14px; }
  .ei-success h3 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 20px; font-weight: 800; color: ${NAVY}; margin-bottom: 8px;
  }
  .ei-success p { font-size: 14px; color: ${GREY}; line-height: 1.6; }

  /* ══ NAVBAR ══ */
  .nav {
    position: fixed; top: 0; left: 0; right: 0; z-index: 1000;
    height: 72px; padding: 0 6%;
    display: flex; align-items: center; justify-content: space-between;
    transition: all 0.4s cubic-bezier(0.4,0,0.2,1);
  }
  .nav.scrolled {
    background: rgba(255,255,255,0.96);
    backdrop-filter: blur(20px);
    border-bottom: 1px solid rgba(31,78,121,0.08);
    box-shadow: 0 4px 24px rgba(0,0,0,0.06);
  }
  .nav-brand { display: flex; align-items: center; gap: 12px; text-decoration: none; }
  .nav-logo-img { height: 128px; width: auto; object-fit: contain; margin-top: 9px; }
  .nav-pill {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 10px; font-weight: 700; letter-spacing: 1.5px;
    text-transform: uppercase; color: ${ORANGE};
    background: rgba(242,101,34,0.10);
    border: 1px solid rgba(242,101,34,0.25);
    padding: 3px 10px; border-radius: 20px;
  }
  .nav-right { display: flex; align-items: center; gap: 8px; }
  .nav-login {
    font-family: 'Inter', sans-serif; font-size: 14px; font-weight: 500;
    color: ${NAVY}; background: none; border: none; cursor: pointer;
    padding: 9px 18px; border-radius: 8px; transition: background 0.2s;
  }
  .nav-login:hover { background: rgba(31,78,121,0.06); }
  .nav-cta {
    font-family: 'Plus Jakarta Sans', sans-serif; font-size: 14px; font-weight: 600;
    color: #fff; background: ${ORANGE}; border: none; cursor: pointer;
    padding: 10px 22px; border-radius: 10px;
    box-shadow: 0 4px 14px rgba(242,101,34,0.35);
    transition: all 0.25s cubic-bezier(0.4,0,0.2,1);
  }
  .nav-cta:hover { background: #e05a1a; transform: translateY(-1px); box-shadow: 0 6px 20px rgba(242,101,34,0.45); }

  /* ══ HERO ══ */
  .hero {
    min-height: 100vh;
    background: linear-gradient(160deg, #ffffff 0%, #f0f7ff 45%, #fff5ef 100%);
    display: flex; align-items: center;
    padding: 110px 6% 80px;
    position: relative; overflow: hidden;
  }
  .hero-grid {
    position: absolute; inset: 0;
    background-image:
      linear-gradient(rgba(31,78,121,0.04) 1px, transparent 1px),
      linear-gradient(90deg, rgba(31,78,121,0.04) 1px, transparent 1px);
    background-size: 60px 60px;
    mask-image: radial-gradient(ellipse 80% 80% at 50% 50%, black 40%, transparent 100%);
  }
  .hero-blob1 {
    position: absolute; top: -120px; right: -80px;
    width: 700px; height: 700px; border-radius: 50%;
    background: radial-gradient(circle, rgba(242,101,34,0.10) 0%, transparent 65%);
    pointer-events: none;
  }
  .hero-blob2 {
    position: absolute; bottom: -200px; left: -100px;
    width: 600px; height: 600px; border-radius: 50%;
    background: radial-gradient(circle, rgba(31,78,121,0.08) 0%, transparent 65%);
    pointer-events: none;
  }
  .hero-inner {
    max-width: 1200px; margin: 0 auto; width: 100%;
    display: grid; grid-template-columns: 55% 45%;
    gap: 40px; align-items: center; position: relative; z-index: 1;
  }
  .hero-eyebrow {
    display: inline-flex; align-items: center; gap: 8px;
    background: rgba(31,78,121,0.06);
    border: 1px solid rgba(31,78,121,0.12);
    padding: 7px 16px; border-radius: 30px; margin-bottom: 28px;
  }
  .eyebrow-dot {
    width: 8px; height: 8px; border-radius: 50%; background: #22c55e;
    box-shadow: 0 0 0 3px rgba(34,197,94,0.2); animation: blink 2s infinite;
  }
  @keyframes blink {
    0%,100% { box-shadow: 0 0 0 3px rgba(34,197,94,0.20); }
    50% { box-shadow: 0 0 0 7px rgba(34,197,94,0.08); }
  }
  .eyebrow-text { font-size: 13px; font-weight: 500; color: ${NAVY}; }

  .hero-h1 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 62px; font-weight: 800; line-height: 1.06;
    letter-spacing: -2.5px; color: #0f172a; margin-bottom: 6px;
  }
  .hero-h1-orange {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 62px; font-weight: 800; line-height: 1.06;
    letter-spacing: -2.5px; color: ${ORANGE};
    display: block; margin-bottom: 6px;
  }
  .hero-h1-navy {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 62px; font-weight: 800; line-height: 1.06;
    letter-spacing: -2.5px; color: ${NAVY};
    display: block; margin-bottom: 28px;
  }
  .hero-sub {
    font-size: 18px; line-height: 1.75; color: ${GREY};
    max-width: 480px; margin-bottom: 28px;
  }
  .hero-sub strong { color: #0f172a; font-weight: 600; }

  /* USP Bullets */
  .usp-bullets {
    display: flex; flex-direction: column; gap: 10px; margin-bottom: 36px;
  }
  .usp-item {
    display: flex; align-items: center; gap: 10px;
    font-size: 15px; font-weight: 500; color: #0f172a;
  }
  .usp-check {
    width: 22px; height: 22px; border-radius: 50%; flex-shrink: 0;
    background: rgba(34,197,94,0.12);
    display: flex; align-items: center; justify-content: center;
    color: #16a34a; font-size: 12px; font-weight: 700;
  }

  /* Access Card */
  .access-card {
    background: #fff; border: 1px solid rgba(31,78,121,0.12);
    border-radius: 20px; padding: 28px;
    box-shadow: 0 8px 48px rgba(31,78,121,0.10), 0 1px 3px rgba(0,0,0,0.05);
    max-width: 480px;
  }
  .access-label {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 16px; font-weight: 700; color: #0f172a; margin-bottom: 16px;
  }
  .input-row { display: flex; gap: 10px; margin-bottom: 14px; }
  .input-prefix {
    display: flex; align-items: center;
    background: ${LIGHT}; border: 1.5px solid #e2e8f0;
    border-radius: 10px; padding: 0 14px;
    font-size: 14px; font-weight: 600; color: ${NAVY};
    white-space: nowrap; gap: 6px;
  }
  .input-field {
    flex: 1; border: 1.5px solid #e2e8f0; border-radius: 10px;
    padding: 13px 16px; font-family: 'Inter', sans-serif;
    font-size: 15px; color: #0f172a; background: ${LIGHT};
    outline: none; transition: all 0.2s;
  }
  .input-field:focus { border-color: ${ORANGE}; background: #fff; box-shadow: 0 0 0 3px rgba(242,101,34,0.10); }
  .input-field::placeholder { color: #94a3b8; }
  .btn-wa {
    width: 100%;
    background: linear-gradient(135deg, #25d366, #128c7e);
    color: #fff; border: none; cursor: pointer;
    padding: 15px; border-radius: 10px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 15px; font-weight: 700;
    display: flex; align-items: center; justify-content: center; gap: 10px;
    transition: all 0.25s cubic-bezier(0.4,0,0.2,1);
    box-shadow: 0 4px 16px rgba(37,211,102,0.30);
  }
  .btn-wa:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(37,211,102,0.40); }
  .btn-wa:disabled { background: #cbd5e1; transform: none; box-shadow: none; cursor: not-allowed; }
  .wa-icon { font-size: 20px; }
  .access-note {
    display: flex; align-items: center; justify-content: center; gap: 6px;
    font-size: 12px; color: #94a3b8; margin-top: 12px;
  }
  .access-success { text-align: center; padding: 12px 0; }
  .success-icon { font-size: 48px; margin-bottom: 14px; }
  .access-success h3 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 20px; font-weight: 800; color: ${NAVY}; margin-bottom: 8px;
  }
  .access-success p { font-size: 14px; color: ${GREY}; line-height: 1.6; }

  /* Early adopter strip */
  .early-strip {
    display: flex; align-items: center; gap: 12px; margin-top: 20px;
  }
  .spot-badge {
    background: rgba(242,101,34,0.10); border: 1px solid rgba(242,101,34,0.20);
    border-radius: 20px; padding: 5px 14px;
    font-size: 12px; font-weight: 700; color: ${ORANGE};
    white-space: nowrap;
  }
  .early-text { font-size: 12px; color: ${GREY}; line-height: 1.5; }

  /* ══ PHONE MOCKUP ══ */
  .hero-right { display: flex; flex-direction: column; align-items: center; gap: 16px; }
  .mockup-label {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13px; font-weight: 700; color: ${NAVY};
    text-transform: uppercase; letter-spacing: 1.5px;
    background: rgba(31,78,121,0.06); border: 1px solid rgba(31,78,121,0.12);
    padding: 6px 16px; border-radius: 20px;
  }
  .phone-frame {
    width: 300px; background: #fff; border-radius: 40px;
    box-shadow: 0 40px 100px rgba(31,78,121,0.22), 0 8px 24px rgba(0,0,0,0.10), inset 0 0 0 1px rgba(255,255,255,0.6);
    overflow: hidden; border: 8px solid #111827; position: relative;
  }
  .phone-notch {
    height: 26px; background: #111827;
    display: flex; align-items: center; justify-content: center;
  }
  .notch-bar { width: 72px; height: 7px; background: #0a0f1a; border-radius: 4px; }
  .wa-head {
    background: linear-gradient(135deg, #075e54, #128c7e);
    padding: 10px 14px; display: flex; align-items: center; gap: 10px;
  }
  .wa-back { color: rgba(255,255,255,0.8); font-size: 16px; }
  .wa-av {
    width: 36px; height: 36px; border-radius: 50%; flex-shrink: 0;
    background: linear-gradient(135deg, ${ORANGE}, #e05a1a);
    display: flex; align-items: center; justify-content: center;
    font-family: 'Plus Jakarta Sans', sans-serif; font-size: 14px; font-weight: 800; color: #fff;
  }
  .wa-info { flex: 1; }
  .wa-name { color: #fff; font-size: 13px; font-weight: 600; line-height: 1.2; }
  .wa-status { color: rgba(255,255,255,0.65); font-size: 10px; }
  .wa-acts { display: flex; gap: 12px; color: rgba(255,255,255,0.75); font-size: 15px; }
  .wa-body {
    background: #e5ddd5;
    min-height: 380px; padding: 12px 10px;
    display: flex; flex-direction: column; gap: 7px;
  }
  .date-chip { text-align: center; margin-bottom: 4px; }
  .date-chip span {
    background: rgba(255,255,255,0.80); font-size: 10px; color: #555;
    padding: 3px 12px; border-radius: 10px;
  }
  .msg { display: flex; }
  .msg.in { justify-content: flex-start; }
  .msg.out { justify-content: flex-end; }
  .bub {
    max-width: 84%; padding: 8px 11px 5px;
    border-radius: 12px; font-size: 12px; line-height: 1.5;
    box-shadow: 0 1px 2px rgba(0,0,0,0.12);
    animation: popIn 0.4s ease forwards; opacity: 0;
  }
  @keyframes popIn { from { opacity:0; transform:translateY(6px); } to { opacity:1; transform:translateY(0); } }
  .bub.in { background: #fff; border-radius: 2px 12px 12px 12px; color: #1a1a2e; }
  .bub.out { background: #dcf8c6; border-radius: 12px 2px 12px 12px; color: #1a1a2e; }
  .bub-time { font-size: 9.5px; color: #999; text-align: right; margin-top: 3px; }
  .tick { color: #4fc3f7; }
  .img-msg {
    background: linear-gradient(135deg, #dbeafe, #e0f2fe);
    border-radius: 8px; padding: 10px; margin-bottom: 3px;
    display: flex; align-items: center; gap: 8px;
  }
  .img-ico { font-size: 22px; }
  .img-nm { font-size: 11px; font-weight: 600; color: ${NAVY}; }
  .img-sz { font-size: 9px; color: #94a3b8; }
  .rcpt {
    background: #fff; border-radius: 10px; overflow: hidden;
    box-shadow: 0 2px 8px rgba(0,0,0,0.12); margin-bottom: 3px;
  }
  .rcpt-head {
    background: linear-gradient(135deg, ${NAVY}, #2563eb);
    padding: 9px 12px; display: flex; align-items: center; gap: 6px;
  }
  .rcpt-head-txt { color: #fff; font-size: 11px; font-weight: 700; letter-spacing: 0.5px; }
  .rcpt-body { padding: 9px 12px; }
  .rr {
    display: flex; justify-content: space-between;
    font-size: 11px; padding: 3px 0;
    border-bottom: 1px solid #f1f5f9;
  }
  .rr:last-child { border-bottom: none; }
  .rl { color: #64748b; }
  .rv { font-weight: 600; color: #0f172a; }
  .rv.g { color: #16a34a; }
  .wa-bar {
    background: #f0f0f0; padding: 7px 9px;
    display: flex; align-items: center; gap: 7px;
  }
  .wa-inp { flex: 1; background: #fff; border-radius: 18px; padding: 7px 13px; font-size: 11px; color: #999; border: none; outline: none; }
  .wa-send-btn { width: 32px; height: 32px; border-radius: 50%; background: #075e54; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 13px; flex-shrink: 0; }

  /* ══ FOR LANDLORDS WHO ══ */
  .identity { background: ${NAVY}; padding: 80px 6%; }
  .identity-inner { max-width: 1200px; margin: 0 auto; text-align: center; }
  .identity h2 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: clamp(28px, 3vw, 42px); font-weight: 800;
    color: #fff; margin-bottom: 16px; letter-spacing: -0.5px;
  }
  .identity-sub { font-size: 16px; color: rgba(255,255,255,0.55); margin-bottom: 52px; }
  .identity-grid {
    display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px;
  }
  .id-card {
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.10);
    border-radius: 16px; padding: 28px 24px;
    text-align: left; transition: all 0.3s;
  }
  .id-card:hover { background: rgba(255,255,255,0.08); transform: translateY(-4px); }
  .id-emoji { font-size: 28px; margin-bottom: 14px; display: block; }
  .id-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 15px; font-weight: 700; color: #fff; margin-bottom: 8px;
  }
  .id-desc { font-size: 13px; color: rgba(255,255,255,0.50); line-height: 1.7; }

  /* ══ STATS ══ */
  .stats { background: #0f172a; }
  .stats-inner {
    max-width: 1200px; margin: 0 auto; padding: 0 6%;
    display: grid; grid-template-columns: repeat(4, 1fr);
  }
  .stat {
    padding: 44px 28px; text-align: center;
    border-right: 1px solid rgba(255,255,255,0.07);
  }
  .stat:last-child { border-right: none; }
  .stat-num {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 36px; font-weight: 800; color: ${ORANGE};
    line-height: 1; margin-bottom: 8px; letter-spacing: -1px;
  }
  .stat-lbl { font-size: 13px; color: rgba(255,255,255,0.45); line-height: 1.6; }

  /* ══ SECTIONS ══ */
  .section { padding: 110px 6%; }
  .section-inner { max-width: 1200px; margin: 0 auto; }
  .eyebrow {
    display: inline-block; font-size: 11px; font-weight: 700;
    color: ${ORANGE}; text-transform: uppercase; letter-spacing: 2px; margin-bottom: 14px;
  }
  .sec-h2 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: clamp(30px, 3vw, 44px); font-weight: 800;
    color: #0f172a; line-height: 1.15; letter-spacing: -1px; margin-bottom: 14px;
  }
  .sec-p {
    font-size: 16px; color: ${GREY}; line-height: 1.75;
    max-width: 520px; margin-bottom: 60px;
  }

  /* ══ HOW IT WORKS ══ */
  .how { background: #fff; }
  .steps { display: grid; grid-template-columns: repeat(3,1fr); gap: 28px; }
  .step {
    background: ${LIGHT}; border: 1px solid rgba(31,78,121,0.08);
    border-radius: 20px; padding: 36px 28px; position: relative; overflow: hidden;
    transition: all 0.3s cubic-bezier(0.4,0,0.2,1);
  }
  .step::after {
    content: ''; position: absolute; top: 0; left: 0; right: 0; height: 4px;
    background: linear-gradient(90deg, ${NAVY}, ${ORANGE});
    transform: scaleX(0); transform-origin: left; transition: transform 0.4s;
  }
  .step:hover { transform: translateY(-6px); box-shadow: 0 24px 64px rgba(31,78,121,0.12); }
  .step:hover::after { transform: scaleX(1); }
  .step-badge {
    width: 42px; height: 42px; border-radius: 12px; margin-bottom: 18px;
    background: linear-gradient(135deg, ${NAVY}, #2563eb);
    display: flex; align-items: center; justify-content: center;
    font-family: 'Plus Jakarta Sans', sans-serif; font-size: 18px; font-weight: 800; color: #fff;
    box-shadow: 0 4px 16px rgba(31,78,121,0.30);
  }
  .step-emoji { font-size: 30px; margin-bottom: 14px; display: block; }
  .step-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 18px; font-weight: 700; color: #0f172a; margin-bottom: 10px;
  }
  .step-desc { font-size: 14px; color: ${GREY}; line-height: 1.75; }

  /* ══ FEATURES ══ */
  .features { background: ${LIGHT}; }
  .feats { display: grid; grid-template-columns: repeat(3,1fr); gap: 18px; }
  .feat {
    background: #fff; border: 1px solid rgba(31,78,121,0.08);
    border-radius: 18px; padding: 28px; transition: all 0.3s;
  }
  .feat:hover { transform: translateY(-4px); box-shadow: 0 20px 50px rgba(31,78,121,0.10); }
  .feat-ico {
    width: 50px; height: 50px; border-radius: 14px; margin-bottom: 16px;
    background: linear-gradient(135deg, rgba(31,78,121,0.08), rgba(242,101,34,0.08));
    display: flex; align-items: center; justify-content: center; font-size: 22px;
  }
  .feat-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 15px; font-weight: 700; color: #0f172a; margin-bottom: 8px;
  }
  .feat-desc { font-size: 13.5px; color: ${GREY}; line-height: 1.75; }

  /* ══ WHY ══ */
  .why { background: #fff; }
  .why-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: start; }
  .why-points { list-style: none; margin-top: 8px; }
  .why-pt {
    display: flex; gap: 14px; padding: 18px 0;
    border-bottom: 1px solid rgba(31,78,121,0.07);
  }
  .why-pt:last-child { border-bottom: none; }
  .why-ck {
    width: 28px; height: 28px; border-radius: 50%; flex-shrink: 0; margin-top: 1px;
    background: rgba(242,101,34,0.10);
    display: flex; align-items: center; justify-content: center;
    color: ${ORANGE}; font-size: 13px; font-weight: 700;
  }
  .why-pt-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 15px; font-weight: 700; color: #0f172a; margin-bottom: 4px;
  }
  .why-pt-desc { font-size: 13px; color: ${GREY}; line-height: 1.6; }
  .compare {
    background: ${LIGHT}; border: 1px solid rgba(31,78,121,0.10);
    border-radius: 20px; overflow: hidden;
    box-shadow: 0 4px 24px rgba(31,78,121,0.08);
  }
  .cmp-head {
    display: grid; grid-template-columns: 1.4fr 1fr 1fr;
    background: rgba(31,78,121,0.06); padding: 14px 20px;
    border-bottom: 1px solid rgba(31,78,121,0.08);
  }
  .cmp-head span { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; color: #94a3b8; }
  .cmp-head span.on { color: ${ORANGE}; }
  .cmp-row {
    display: grid; grid-template-columns: 1.4fr 1fr 1fr;
    padding: 13px 20px; border-bottom: 1px solid rgba(31,78,121,0.05); align-items: center;
  }
  .cmp-row:last-child { border-bottom: none; }
  .cf { font-size: 13px; color: ${GREY}; }
  .cn { text-align: center; color: #ef4444; font-size: 16px; }
  .cy { text-align: center; color: #16a34a; font-size: 14px; font-weight: 700; }
  .ct { text-align: center; font-size: 11px; font-weight: 700; }
  .ct.bad { color: #ef4444; }
  .ct.good { color: #16a34a; }

  /* ══ TESTIMONIALS ══ */
  .testi { background: ${LIGHT}; }
  .tgrid { display: grid; grid-template-columns: repeat(3,1fr); gap: 22px; }
  .tcard {
    background: #fff; border: 1px solid rgba(31,78,121,0.08);
    border-radius: 20px; padding: 28px; transition: all 0.3s;
  }
  .tcard:hover { transform: translateY(-4px); box-shadow: 0 20px 50px rgba(31,78,121,0.10); }
  .tstars { color: ${ORANGE}; font-size: 14px; letter-spacing: 3px; margin-bottom: 14px; }
  .tquote { font-size: 14px; color: #374151; line-height: 1.80; margin-bottom: 20px; font-style: italic; }
  .tauthor { display: flex; align-items: center; gap: 12px; }
  .tav {
    width: 40px; height: 40px; border-radius: 50%;
    background: linear-gradient(135deg, ${NAVY}, ${ORANGE});
    display: flex; align-items: center; justify-content: center;
    font-family: 'Plus Jakarta Sans', sans-serif; font-size: 15px; font-weight: 800; color: #fff;
  }
  .tname { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 14px; font-weight: 700; color: #0f172a; }
  .tdetail { font-size: 12px; color: #94a3b8; margin-top: 1px; }

  /* ══ FAQ ══ */
  .faq { background: #fff; }
  .faq-wrap { max-width: 740px; margin: 0 auto; }
  .faq-item {
    border: 1px solid rgba(31,78,121,0.08); border-radius: 14px;
    margin-bottom: 10px; overflow: hidden; background: ${LIGHT}; transition: all 0.25s;
  }
  .faq-item.open { border-color: rgba(242,101,34,0.25); background: #fff; box-shadow: 0 4px 20px rgba(242,101,34,0.08); }
  .faq-btn {
    width: 100%; background: none; border: none; cursor: pointer;
    padding: 20px 24px; display: flex; justify-content: space-between; align-items: center;
    font-family: 'Plus Jakarta Sans', sans-serif; font-size: 15px; font-weight: 600; color: #0f172a; text-align: left;
  }
  .faq-ico {
    width: 28px; height: 28px; border-radius: 50%; flex-shrink: 0; margin-left: 16px;
    background: rgba(31,78,121,0.08); display: flex; align-items: center; justify-content: center;
    font-size: 18px; color: ${ORANGE}; transition: all 0.3s; font-weight: 300;
  }
  .faq-item.open .faq-ico { background: rgba(242,101,34,0.10); transform: rotate(45deg); }
  .faq-ans { padding: 0 24px 20px; font-size: 14px; color: ${GREY}; line-height: 1.80; display: none; }
  .faq-item.open .faq-ans { display: block; }

  /* ══ CTA BOTTOM ══ */
  .cta-sec {
    padding: 120px 6%;
    background: linear-gradient(160deg, ${NAVY} 0%, #0d2d52 50%, #07152a 100%);
    text-align: center; position: relative; overflow: hidden;
  }
  .cta-blob {
    position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%);
    width: 900px; height: 500px; border-radius: 50%;
    background: radial-gradient(ellipse, rgba(242,101,34,0.15) 0%, transparent 65%);
    pointer-events: none;
  }
  .cta-inner { max-width: 640px; margin: 0 auto; position: relative; z-index: 1; }
  .cta-inner h2 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: clamp(30px, 4vw, 50px); font-weight: 800;
    color: #fff; line-height: 1.15; letter-spacing: -1px; margin-bottom: 18px;
  }
  .cta-inner p { font-size: 17px; color: rgba(255,255,255,0.55); margin-bottom: 44px; line-height: 1.7; }
  .btn-cta-xl {
    background: linear-gradient(135deg, ${ORANGE}, #e05a1a);
    color: #fff; border: none; cursor: pointer;
    padding: 18px 52px; border-radius: 12px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 17px; font-weight: 700;
    box-shadow: 0 8px 32px rgba(242,101,34,0.45);
    transition: all 0.3s cubic-bezier(0.4,0,0.2,1);
  }
  .btn-cta-xl:hover { transform: translateY(-3px); box-shadow: 0 16px 48px rgba(242,101,34,0.55); }

  /* ══ FOOTER ══ */
  .footer { background: #060f1e; padding: 72px 6% 36px; }
  .footer-inner { max-width: 1200px; margin: 0 auto; }
  .footer-top {
    display: grid; grid-template-columns: 2.2fr 1fr 1fr 1fr;
    gap: 56px; margin-bottom: 48px; padding-bottom: 48px;
    border-bottom: 1px solid rgba(255,255,255,0.07);
  }
  .footer-logo { height: 128px; width: auto; object-fit: contain; margin-bottom: 16px; display: block; }
  .footer-desc { font-size: 13px; color: rgba(255,255,255,0.40); line-height: 1.75; max-width: 260px; }
  .fcol-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 11px; font-weight: 700; color: rgba(255,255,255,0.30);
    text-transform: uppercase; letter-spacing: 1.5px; margin-bottom: 20px;
  }
  .flink {
    display: block; font-size: 13.5px; color: rgba(255,255,255,0.50);
    text-decoration: none; margin-bottom: 12px; transition: color 0.2s;
  }
  .flink:hover { color: ${ORANGE}; }
  .soon {
    display: inline-block; font-size: 10px; font-weight: 700;
    color: rgba(255,255,255,0.35); background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.10);
    padding: 3px 10px; border-radius: 20px; margin-bottom: 10px;
  }
  .footer-bottom {
    display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px;
  }
  .fcopy { font-size: 12px; color: rgba(255,255,255,0.28); line-height: 1.6; }
  .ftag { font-size: 12px; font-weight: 600; color: rgba(255,255,255,0.22); font-family: 'Plus Jakarta Sans', sans-serif; }

  /* ══ RESPONSIVE ══ */
  @media (max-width: 1024px) {
    .hero-inner { grid-template-columns: 1fr; }
    .phone-frame { display: none; }
    .mockup-label { display: none; }
    .hero-h1, .hero-h1-orange, .hero-h1-navy { font-size: 44px; }
    .stats-inner { grid-template-columns: repeat(2,1fr); }
    .identity-grid { grid-template-columns: repeat(2, 1fr); }
    .why-grid { grid-template-columns: 1fr; gap: 48px; }
    .footer-top { grid-template-columns: 1fr 1fr; gap: 40px; }
  }
  @media (max-width: 768px) {
    .steps, .feats, .tgrid { grid-template-columns: 1fr; }
    .hero-h1, .hero-h1-orange, .hero-h1-navy { font-size: 36px; letter-spacing: -1px; }
    .identity-grid { grid-template-columns: 1fr; }
    .footer-top { grid-template-columns: 1fr; }
    .footer-bottom { flex-direction: column; text-align: center; }
    .section { padding: 64px 5%; }
    .hero { padding: 90px 5% 48px; }
    .cta-sec { padding: 72px 5%; }
    .stats-inner { grid-template-columns: repeat(2,1fr); }
    .compare-card { display: none; }
  }

  @media (max-width: 480px) {
    /* Navbar — shrink logo and buttons to fit all 3 items */
    .nav { height: 72px; padding: 0 3%; }
    .nav-logo-img { height: 56px; margin-top: 4px; }
    .nav-pill { font-size: 9px; padding: 2px 6px; letter-spacing: 1px; }
    .nav-login {
      font-size: 12px; padding: 7px 10px; border-radius: 7px;
    }
    .nav-cta {
      font-size: 12px; padding: 8px 12px; border-radius: 8px;
    }

    /* Hero */
    .hero { padding: 90px 4% 48px; }
    .hero-h1, .hero-h1-orange, .hero-h1-navy {
      font-size: 30px; letter-spacing: -0.5px;
    }
    .hero-sub { font-size: 15px; }
    .usp-item { font-size: 13px; }
    .access-card { padding: 20px 18px; }
    .input-field { font-size: 14px; padding: 11px 12px; }
    .btn-access { font-size: 13px; padding: 13px; }
    .early-strip { flex-direction: column; align-items: flex-start; gap: 6px; }

    /* Stats */
    .stat { padding: 24px 14px; }
    .stat-num { font-size: 26px; }
    .stat-lbl { font-size: 11px; }

    /* Sections */
    .section { padding: 56px 4%; }
    .sec-h2 { font-size: 26px; }
    .sec-p { font-size: 14px; margin-bottom: 40px; }

    /* Cards */
    .step { padding: 24px 20px; }
    .feat { padding: 22px 18px; }
    .id-card { padding: 20px 18px; }
    .tcard { padding: 22px 18px; }

    /* Identity */
    .identity { padding: 56px 4%; }
    .identity-grid { grid-template-columns: 1fr; gap: 12px; }

    /* FAQ */
    .faq-btn { font-size: 14px; padding: 16px 18px; }

    /* CTA */
    .cta-sec { padding: 64px 4%; }
    .cta-inner h2 { font-size: 26px; }
    .cta-inner p { font-size: 14px; }
    .btn-cta-xl { padding: 14px 28px; font-size: 14px; }

    /* Footer */
    .footer { padding: 48px 4% 28px; }
    .footer-top { grid-template-columns: 1fr; gap: 32px; }
    .footer-logo { height: 80px; }

    /* Exit popup */
    .ei-card { border-radius: 16px; }
    .ei-top { padding: 24px 20px 20px; }
    .ei-h2 { font-size: 22px; }
    .ei-body { padding: 20px 20px 24px; }
    .ei-input-row { flex-direction: column; gap: 8px; }
    .ei-prefix { padding: 10px 14px; justify-content: center; }
    .ei-btn { font-size: 13px; }
  }
`;

const FEATURES = [
  { icon: '📱', title: 'WhatsApp Native', desc: 'Tenants pay via GPay or PhonePe and forward the screenshot. No app, no login, no new behaviour needed.' },
  { icon: '🤖', title: 'AI Payment Reading', desc: 'Our AI reads every screenshot instantly — amount, transaction ID and date extracted automatically, every time.' },
  { icon: '🧾', title: 'Instant Receipts', desc: 'The moment a payment is confirmed, a professional PDF receipt is generated and sent to the tenant on WhatsApp.' },
  { icon: '⏰', title: 'Smart Reminders', desc: 'Automated reminders go out before due date, on due date, and when overdue. No manual follow-up ever again.' },
  { icon: '🏢', title: 'Multi-Property', desc: 'Manage all your buildings and units from one clean dashboard. Paid, unpaid, overdue — all at a glance.' },
  { icon: '📊', title: 'Complete Records', desc: 'Every payment, receipt and reminder is logged and downloadable. Ready for your CA or bank whenever you need.' },
];

const WHY_PTS = [
  { title: 'Zero tenant friction', desc: 'Tenants don\'t install anything. They pay as always and send one screenshot.' },
  { title: 'Live in under 5 minutes', desc: 'Add your properties, units and tenants. First reminder goes out automatically.' },
  { title: 'Bank-grade data security', desc: 'Encrypted storage. Tenant documents auto-deleted 90 days after move-out.' },
  { title: 'Every UPI app supported', desc: 'GPay, PhonePe, Paytm, CRED, Amazon Pay — all work seamlessly.' },
];

const COMPARE = [
  { f: 'Rent reminders', m: '✗', h: '✓' },
  { f: 'Payment receipts', m: '✗', h: '✓' },
  { f: 'Screenshot reading', m: '✗', h: '✓' },
  { f: 'Payment history', m: '✗', h: '✓' },
  { f: 'Multi-property view', m: '✗', h: '✓' },
  { f: 'Time spent/month', m: '4+ hrs', h: '< 10 min', time: true },
];

const TESTIMONIALS = [
  { q: '"I used to spend every 5th of the month chasing 8 tenants. Now Hashvi sends the reminders and I just approve the payments. It has completely changed how I manage my properties."', n: 'Ramesh K.', d: 'Landlord, 8 units · Bangalore', i: 'R' },
  { q: '"My tenants are not very tech-savvy. But they pay on GPay as usual and send me a photo. No confusion at all. Hashvi handles everything else automatically."', n: 'Meenakshi S.', d: 'Landlord, 5 units · Chennai', i: 'M' },
  { q: '"The receipts look so professional. My tenants appreciate getting a proper PDF every month. It has built a lot of trust and my rent is now collected 100% on time."', n: 'Arjun P.', d: 'Landlord, 12 units · Hyderabad', i: 'A' },
];

const FAQS = [
  { q: 'How much time does this actually save me?', a: 'Most landlords spend 2-4 hours a month on rent follow-ups, confirmations, and receipts. With Hashvi Rental, that drops to under 10 minutes — just reviewing and approving payments as they come in.' },
  { q: 'Do my tenants need to download any app?', a: 'Nothing at all. They pay via GPay, PhonePe, or any UPI app as usual — then send the screenshot on WhatsApp. No app, no account, no learning curve.' },
  { q: 'What if a tenant pays cash or cheque?', a: 'You can manually record any payment — cash, cheque, bank transfer — from your dashboard. A receipt is automatically generated and sent to the tenant on WhatsApp.' },
  { q: 'Can I manage multiple properties from one account?', a: 'Yes. Add as many buildings and units as you need — all managed from one dashboard with paid, unpaid and overdue status for every unit.' },
  { q: 'How do I get a referral code to register?', a: 'Click "Start on WhatsApp" and enter your number. We\'ll personally send your referral code. Registration takes under 2 minutes with a WhatsApp OTP.' },
  { q: 'Is my data and my tenants\' data safe?', a: 'Absolutely. All data is encrypted. Tenant documents are automatically deleted 90 days after move-out. We never share your data with anyone.' },
];

export default function LandingPage({ onLogin }) {
  const [scrolled, setScrolled] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);
  const [phone, setPhone] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [chatStep, setChatStep] = useState(0);

  // Exit intent state
  const [showExitPopup, setShowExitPopup] = useState(false);
  const [exitPhone, setExitPhone] = useState('');
  const [exitSubmitting, setExitSubmitting] = useState(false);
  const [exitSubmitted, setExitSubmitted] = useState(false);
  const [exitShown, setExitShown] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  // Exit intent — detect mouse leaving toward top of browser
  useEffect(() => {
    const handleMouseLeave = (e) => {
      if (e.clientY <= 10 && !exitShown && !submitted) {
        setShowExitPopup(true);
        setExitShown(true);
      }
    };
    // Also show after 45 seconds if still on page
    const timer = setTimeout(() => {
      if (!exitShown && !submitted) {
        setShowExitPopup(true);
        setExitShown(true);
      }
    }, 45000);
    document.addEventListener('mouseleave', handleMouseLeave);
    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
      clearTimeout(timer);
    };
  }, [exitShown, submitted]);

  useEffect(() => {
    const t = setInterval(() => setChatStep(s => s < 5 ? s + 1 : s), 1400);
    return () => clearInterval(t);
  }, []);

  const scrollToAccess = () => document.getElementById('access')?.scrollIntoView({ behavior: 'smooth' });

  const handleExitRequest = () => {
    const c = exitPhone.replace(/\D/g, '');
    if (c.length < 10) { alert('Please enter a valid 10-digit WhatsApp number.'); return; }
    setExitSubmitting(true);
    const msg = encodeURIComponent(`Hi! I'd like early access to Hashvi Rental.\nMy WhatsApp: +91${c}`);
    window.open(`https://wa.me/919741400302?text=${msg}`, '_blank');
    setTimeout(() => { setExitSubmitting(false); setExitSubmitted(true); }, 900);
  };

  const handleRequest = () => {
    const c = phone.replace(/\D/g, '');
    if (c.length < 10) { alert('Please enter a valid 10-digit WhatsApp number.'); return; }
    setSubmitting(true);
    const msg = encodeURIComponent(`Hi! I'd like early access to Hashvi Rental.\nMy WhatsApp: +91${c}`);
    window.open(`https://wa.me/919741400302?text=${msg}`, '_blank');
    setTimeout(() => { setSubmitting(false); setSubmitted(true); }, 900);
  };

  return (
    <div className="lp">
      <style>{styles}</style>

      {/* ── EXIT INTENT POPUP ── */}
      {showExitPopup && (
        <div className="ei-overlay" onClick={(e) => e.target.className === 'ei-overlay' && setShowExitPopup(false)}>
          <div className="ei-card">
            <div className="ei-top">
              <button className="ei-close" onClick={() => setShowExitPopup(false)}>✕</button>
              <div className="ei-wait-badge">
                <span className="ei-emoji">🏠</span>
                Early Access · Limited Spots
              </div>
              <h2 className="ei-h2">
                Before you go —<br />
                <span>collect rent on autopilot.</span>
              </h2>
              <p className="ei-sub">
                Join the first 100 landlords in Bangalore managing smarter with Hashvi Rental. Takes 2 minutes to get started.
              </p>
            </div>
            <div className="ei-body">
              {exitSubmitted ? (
                <div className="ei-success">
                  <div className="ei-success-icon">🎉</div>
                  <h3>We'll reach out shortly!</h3>
                  <p>Your referral code is on its way to your WhatsApp. Get ready to manage smarter.</p>
                  <button className="ei-skip" onClick={() => setShowExitPopup(false)}>Close</button>
                </div>
              ) : (
                <>
                  <div className="ei-usp">
                    {[
                      'No app for tenants — they pay on GPay as usual',
                      'Automated reminders — stop chasing rent',
                      'PDF receipts sent on WhatsApp instantly',
                    ].map((u, i) => (
                      <div className="ei-usp-item" key={i}>
                        <span className="ei-usp-check">✓</span>{u}
                      </div>
                    ))}
                  </div>
                  <label className="ei-label">Enter your WhatsApp number</label>
                  <div className="ei-input-row">
                    <span className="ei-prefix">🇮🇳 +91</span>
                    <input
                      className="ei-input"
                      type="tel"
                      placeholder="WhatsApp number"
                      value={exitPhone}
                      maxLength={10}
                      onChange={e => setExitPhone(e.target.value.replace(/\D/g, ''))}
                      onKeyDown={e => e.key === 'Enter' && handleExitRequest()}
                    />
                  </div>
                  <button
                    className="ei-btn"
                    onClick={handleExitRequest}
                    disabled={exitSubmitting || exitPhone.length < 10}
                  >
                    <span>💬</span>
                    {exitSubmitting ? 'Opening WhatsApp...' : 'Get My Referral Code →'}
                  </button>
                  <p className="ei-note">🔒 Free to use · No credit card · Setup in 5 minutes</p>
                  <button className="ei-skip" onClick={() => setShowExitPopup(false)}>
                    No thanks, I'll manage manually
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* NAVBAR */}
      <nav className={`nav ${scrolled ? 'scrolled' : ''}`}>
        <a href="/" className="nav-brand">
          <img src="/Hashvi_logo_no_BG.svg" alt="Hashvi" className="nav-logo-img" />
          <span className="nav-pill">Rental</span>
        </a>
        <div className="nav-right">
          <button className="nav-login" onClick={onLogin}>Login</button>
          <button className="nav-cta" onClick={scrollToAccess}>Start on WhatsApp</button>
        </div>
      </nav>

      {/* HERO */}
      <section className="hero">
        <div className="hero-grid" />
        <div className="hero-blob1" />
        <div className="hero-blob2" />
        <div className="hero-inner">
          <div className="hero-left">
            <div className="hero-eyebrow">
              <span className="eyebrow-dot" />
              <span className="eyebrow-text">Now live in Bangalore · Early Access Open</span>
            </div>

            <div className="hero-h1">Collect Rent Automatically.</div>
            <span className="hero-h1-orange">On WhatsApp.</span>
            <span className="hero-h1-navy">Without chasing anyone.</span>

            <p className="hero-sub">
              Still chasing rent every month?<br />
              No follow-ups. No spreadsheets. No missed payments.<br />
              Just rent collected — <strong>on time, automatically.</strong>
            </p>

            {/* USP Bullets */}
            <div className="usp-bullets">
              <div className="usp-item"><span className="usp-check">✓</span>No app for tenants — they pay on GPay as usual</div>
              <div className="usp-item"><span className="usp-check">✓</span>Works with GPay, PhonePe, Paytm, CRED</div>
              <div className="usp-item"><span className="usp-check">✓</span>Setup in 5 minutes · Receipts sent automatically</div>
            </div>

            {/* Access Card */}
            <div className="access-card" id="access">
              {submitted ? (
                <div className="access-success">
                  <div className="success-icon">🎉</div>
                  <h3>We'll reach out shortly!</h3>
                  <p>Your referral code is on its way to your WhatsApp. Get ready to manage smarter.</p>
                </div>
              ) : (
                <>
                  <div className="access-label">Enter your WhatsApp number</div>
                  <div className="input-row">
                    <span className="input-prefix">🇮🇳 +91</span>
                    <input
                      className="input-field"
                      type="tel" placeholder="WhatsApp number"
                      value={phone} maxLength={10}
                      onChange={e => setPhone(e.target.value.replace(/\D/g, ''))}
                      onKeyDown={e => e.key === 'Enter' && handleRequest()}
                    />
                  </div>
                  <button className="btn-wa" onClick={handleRequest} disabled={submitting || phone.length < 10}>
                    <span className="wa-icon">💬</span>
                    {submitting ? 'Opening WhatsApp...' : 'Start on WhatsApp →'}
                  </button>
                  <div className="access-note">🔒 Free to use · No credit card · Setup in 5 minutes</div>
                </>
              )}
            </div>

            {/* Early adopter strip */}
            <div className="early-strip">
              <span className="spot-badge">🚀 Early Access</span>
              <span className="early-text">Only <strong>100 early access spots</strong> for Bangalore landlords.<br />Limited · First come first served</span>
            </div>
          </div>

          {/* WhatsApp Mockup */}
          <div className="hero-right">
            <div className="mockup-label">This is how rent collection looks now</div>
            <div className="phone-frame">
              <div className="phone-notch"><div className="notch-bar" /></div>
              <div className="wa-head">
                <span className="wa-back">‹</span>
                <div className="wa-av">H</div>
                <div className="wa-info">
                  <div className="wa-name">Hashvi Rental</div>
                  <div className="wa-status">WhatsApp Business · Online</div>
                </div>
                <div className="wa-acts"><span>📞</span><span>⋮</span></div>
              </div>
              <div className="wa-body">
                <div className="date-chip"><span>Today</span></div>
                {chatStep >= 1 && (
                  <div className="msg in">
                    <div className="bub in">
                      <div className="img-msg">
                        <span className="img-ico">📸</span>
                        <div><div className="img-nm">GPay_receipt.jpg</div><div className="img-sz">Screenshot · 218 KB</div></div>
                      </div>
                      Rent paid sir 🙏
                      <div className="bub-time">10:42 AM</div>
                    </div>
                  </div>
                )}
                {chatStep >= 2 && (
                  <div className="msg out">
                    <div className="bub out">
                      ✅ Payment confirmed!<br />
                      <strong>₹14,500</strong> · GPay · TXN 8472
                      <div className="bub-time">10:42 AM <span className="tick">✓✓</span></div>
                    </div>
                  </div>
                )}
                {chatStep >= 3 && (
                  <div className="msg out">
                    <div className="bub out" style={{ padding:0, background:'transparent', boxShadow:'none' }}>
                      <div className="rcpt">
                        <div className="rcpt-head"><span>🧾</span><span className="rcpt-head-txt">HASHVI RENTAL RECEIPT</span></div>
                        <div className="rcpt-body">
                          <div className="rr"><span className="rl">Tenant</span><span className="rv">Ravi Kumar</span></div>
                          <div className="rr"><span className="rl">Unit</span><span className="rv">Unit 3B</span></div>
                          <div className="rr"><span className="rl">Month</span><span className="rv">April 2026</span></div>
                          <div className="rr"><span className="rl">Amount</span><span className="rv">₹14,500</span></div>
                          <div className="rr"><span className="rl">Status</span><span className="rv g">✓ Confirmed</span></div>
                        </div>
                      </div>
                      <div className="bub-time" style={{paddingRight:4}}>10:43 AM <span className="tick">✓✓</span></div>
                    </div>
                  </div>
                )}
                {chatStep >= 4 && (
                  <div className="msg in">
                    <div className="bub in">
                      Thank you! Got the receipt 🙏
                      <div className="bub-time">10:43 AM</div>
                    </div>
                  </div>
                )}
              </div>
              <div className="wa-bar">
                <div className="wa-inp">Type a message</div>
                <div className="wa-send-btn">➤</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FOR LANDLORDS WHO */}
      <section className="identity">
        <div className="identity-inner">
          <h2>Built for landlords who are done doing this manually.</h2>
          <p className="identity-sub">If any of these sound familiar — Hashvi Rental is built for you.</p>
          <div className="identity-grid">
            {[
              { e:'😤', t:'Tired of chasing tenants', d:'Still sending "Rent due" messages every month manually? Hashvi sends automated reminders — before, on and after due date.' },
              { e:'📱', t:'Want everything on WhatsApp', d:'No new apps. No portals. No logins. Your tenants pay on GPay and forward the screenshot. That\'s it.' },
              { e:'🏠', t:'Managing your own properties', d:'Not a broker. Not a corporate. Just a landlord with 1-20 units who wants a smarter, simpler way to manage rent.' },
              { e:'📊', t:'Tired of tracking in Excel or notebook', d:'Still checking bank SMS and updating manually? Hashvi keeps every payment tracked and receipts generated automatically.' },
            ].map((c,i) => (
              <div className="id-card" key={i}>
                <span className="id-emoji">{c.e}</span>
                <div className="id-title">{c.t}</div>
                <div className="id-desc">{c.d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="stats">
        <div className="stats-inner">
          <div className="stat"><div className="stat-num">3+ hrs</div><div className="stat-lbl">Saved every month on rent management</div></div>
          <div className="stat"><div className="stat-num">0 apps</div><div className="stat-lbl">Your tenants don't install anything</div></div>
          <div className="stat"><div className="stat-num">100%</div><div className="stat-lbl">WhatsApp-based — no portal, no login</div></div>
          <div className="stat"><div className="stat-num">Instant</div><div className="stat-lbl">Receipts for every confirmed payment</div></div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="section how">
        <div className="section-inner">
          <span className="eyebrow">How it works</span>
          <h2 className="sec-h2">Three steps.<br />That's all it takes.</h2>
          <p className="sec-p">No complex setup. No training your tenants. No new apps for anyone. Just a smarter way to collect rent.</p>
          <div className="steps">
            {[
              { n:'1', e:'🏠', t:'Set up your property', d:'Add buildings, units and tenants in under 5 minutes. Each tenant gets a personalised welcome message on WhatsApp automatically.' },
              { n:'2', e:'📱', t:'Tenant pays & sends screenshot', d:'Tenant pays via GPay or PhonePe as usual and forwards the screenshot on WhatsApp. Our AI reads it instantly.' },
              { n:'3', e:'✅', t:'Receipt sent automatically', d:'You approve with one tap. A professional PDF receipt is sent to the tenant on WhatsApp. Payment recorded. Done.' },
            ].map((s,i) => (
              <div className="step" key={i}>
                <div className="step-badge">{s.n}</div>
                <span className="step-emoji">{s.e}</span>
                <div className="step-title">{s.t}</div>
                <p className="step-desc">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="section features">
        <div className="section-inner">
          <span className="eyebrow">Features</span>
          <h2 className="sec-h2">Built for real landlords in India.</h2>
          <p className="sec-p">Not for corporates. Not for brokers. Just for people managing their own properties — 1 to 20 units.</p>
          <div className="feats">
            {FEATURES.map((f,i) => (
              <div className="feat" key={i}>
                <div className="feat-ico">{f.icon}</div>
                <div className="feat-title">{f.title}</div>
                <p className="feat-desc">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHY HASHVI */}
      <section className="section why">
        <div className="section-inner">
          <div className="why-grid">
            <div>
              <span className="eyebrow">Why Hashvi</span>
              <h2 className="sec-h2">Everything runs automatically.</h2>
              <p className="sec-p">From reminders to receipts — without you lifting a finger.</p>
              <ul className="why-points">
                {WHY_PTS.map((p,i) => (
                  <li className="why-pt" key={i}>
                    <span className="why-ck">✓</span>
                    <div>
                      <div className="why-pt-title">{p.title}</div>
                      <div className="why-pt-desc">{p.desc}</div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <div className="compare">
              <div className="cmp-head">
                <span>Feature</span><span>Manual</span><span className="on">Hashvi</span>
              </div>
              {COMPARE.map((r,i) => (
                <div className="cmp-row" key={i}>
                  <span className="cf">{r.f}</span>
                  {r.time ? <><span className="ct bad">{r.m}</span><span className="ct good">{r.h}</span></> : <><span className="cn">{r.m}</span><span className="cy">{r.h}</span></>}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="section testi">
        <div className="section-inner">
          <span className="eyebrow">Early Feedback</span>
          <h2 className="sec-h2">Landlords love it.</h2>
          <p className="sec-p">Here's what early users say after their first month with Hashvi Rental.</p>
          <div className="tgrid">
            {TESTIMONIALS.map((t,i) => (
              <div className="tcard" key={i}>
                <div className="tstars">★★★★★</div>
                <p className="tquote">{t.q}</p>
                <div className="tauthor">
                  <div className="tav">{t.i}</div>
                  <div><div className="tname">{t.n}</div><div className="tdetail">{t.d}</div></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="section faq">
        <div className="section-inner">
          <div className="faq-wrap">
            <span className="eyebrow">FAQ</span>
            <h2 className="sec-h2">Questions answered.</h2>
            <div style={{ marginTop: 48 }}>
              {FAQS.map((f,i) => (
                <div className={`faq-item ${openFaq===i?'open':''}`} key={i}>
                  <button className="faq-btn" onClick={() => setOpenFaq(openFaq===i?null:i)}>
                    {f.q}<span className="faq-ico">+</span>
                  </button>
                  <div className="faq-ans">{f.a}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA BOTTOM */}
      <section className="cta-sec">
        <div className="cta-blob" />
        <div className="cta-inner">
          <h2>Stop chasing rent.<br />Start collecting it automatically.</h2>
          <p>Join the first 100 landlords in Bangalore managing smarter with Hashvi Rental. Limited early access spots available.</p>
          <button className="btn-cta-xl" onClick={scrollToAccess}>
            Start Collecting Rent Automatically →
          </button>
          <div style={{ marginTop: 20, fontSize: 13, color: 'rgba(255,255,255,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 20 }}>
            <span>✓ No setup fees</span>
            <span>✓ No contracts</span>
            <span>✓ Cancel anytime</span>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-top">
            <div>
              <img src="/Hashvi_logo_no_BG.svg" alt="Hashvi" className="footer-logo" />
              <p className="footer-desc">Hashvi Rental is a product of Hashvi Ventures Private Limited. Built in Bangalore for Indian landlords who deserve a smarter way to collect rent.</p>
            </div>
            <div>
              <div className="fcol-title">Product</div>
              <a href="#access" className="flink" onClick={e=>{e.preventDefault();scrollToAccess();}}>Get Early Access</a>
              <a href="/" className="flink" onClick={e=>{e.preventDefault();onLogin();}}>Login</a>
              <a href="/privacy-policy" className="flink">Privacy Policy</a>
            </div>
            <div>
              <div className="fcol-title">Coming Soon</div>
              <span className="soon">Hashvi PG</span><br />
              <span className="soon" style={{marginTop:8}}>Hashvi Stay</span>
            </div>
            <div>
              <div className="fcol-title">Contact</div>
              <a href="mailto:support@hashvi.in" className="flink">support@hashvi.in</a>
              <a href={`https://wa.me/919741400302?text=${encodeURIComponent('Hi, I need help with Hashvi Rental')}`} target="_blank" rel="noreferrer" className="flink">WhatsApp Support</a>
              <a href="https://hashvi.in" className="flink">hashvi.in</a>
            </div>
          </div>
          <div className="footer-bottom">
            <p className="fcopy">© 2026 Hashvi Ventures Private Limited · CIN U62020KA2026PTC218075 · Bangalore, Karnataka, India</p>
            <span className="ftag">Built in Bangalore for Indian landlords.</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
